/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TaxiRouteImport } from './routes/taxi'
import { Route as StaysRouteImport } from './routes/stays'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as MyBookingsRouteImport } from './routes/my-bookings'
import { Route as DriverRouteImport } from './routes/driver'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as BookingPolicyRouteImport } from './routes/booking-policy'
import { Route as BookRouteImport } from './routes/book'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AmenitiesRouteImport } from './routes/amenities'
import { Route as AgencyRouteImport } from './routes/agency'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StaysIdRouteImport } from './routes/stays_.$id'
import { Route as MyBookingsReferenceRouteImport } from './routes/my-bookings_.$reference'
import { Route as AgencySignupRouteImport } from './routes/agency_.signup'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin.users'
import { Route as AuthenticatedAdminTaxiRouteImport } from './routes/_authenticated/admin.taxi'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated/admin.settings'
import { Route as AuthenticatedAdminReportsRouteImport } from './routes/_authenticated/admin.reports'
import { Route as AuthenticatedAdminRefundsRouteImport } from './routes/_authenticated/admin.refunds'
import { Route as AuthenticatedAdminEnquiriesRouteImport } from './routes/_authenticated/admin.enquiries'
import { Route as AuthenticatedAdminDriversRouteImport } from './routes/_authenticated/admin.drivers'
import { Route as AuthenticatedAdminChannelsRouteImport } from './routes/_authenticated/admin.channels'
import { Route as AuthenticatedAdminCalendarRouteImport } from './routes/_authenticated/admin.calendar'
import { Route as AuthenticatedAdminBookingsRouteImport } from './routes/_authenticated/admin.bookings'
import { Route as AuthenticatedAdminBeds24RouteImport } from './routes/_authenticated/admin.beds24'
import { Route as AuthenticatedAdminApartmentsRouteImport } from './routes/_authenticated/admin.apartments'
import { Route as AuthenticatedAdminAgenciesRouteImport } from './routes/_authenticated/admin.agencies'
import { Route as AuthenticatedAdminChannelsIndexRouteImport } from './routes/_authenticated/admin.channels.index'
import { Route as AuthenticatedAdminTaxiIdRouteImport } from './routes/_authenticated/admin.taxi_.$id'
import { Route as AuthenticatedAdminInsightsSlugRouteImport } from './routes/_authenticated/admin.insights.$slug'
import { Route as AuthenticatedAdminDriversIdRouteImport } from './routes/_authenticated/admin.drivers_.$id'
import { Route as AuthenticatedAdminChannelsVrboRouteImport } from './routes/_authenticated/admin.channels.vrbo'
import { Route as AuthenticatedAdminChannelsExpediaRouteImport } from './routes/_authenticated/admin.channels.expedia'
import { Route as AuthenticatedAdminChannelsDirectRouteImport } from './routes/_authenticated/admin.channels.direct'
import { Route as AuthenticatedAdminChannelsBookingRouteImport } from './routes/_authenticated/admin.channels.booking'
import { Route as AuthenticatedAdminChannelsAirbnbRouteImport } from './routes/_authenticated/admin.channels.airbnb'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const TaxiRoute = TaxiRouteImport.update({
  id: '/taxi',
  path: '/taxi',
  getParentRoute: () => rootRouteImport,
} as any)
const StaysRoute = StaysRouteImport.update({
  id: '/stays',
  path: '/stays',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const MyBookingsRoute = MyBookingsRouteImport.update({
  id: '/my-bookings',
  path: '/my-bookings',
  getParentRoute: () => rootRouteImport,
} as any)
const DriverRoute = DriverRouteImport.update({
  id: '/driver',
  path: '/driver',
  getParentRoute: () => rootRouteImport,
} as any)
const CookiesRoute = CookiesRouteImport.update({
  id: '/cookies',
  path: '/cookies',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingPolicyRoute = BookingPolicyRouteImport.update({
  id: '/booking-policy',
  path: '/booking-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const BookRoute = BookRouteImport.update({
  id: '/book',
  path: '/book',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AmenitiesRoute = AmenitiesRouteImport.update({
  id: '/amenities',
  path: '/amenities',
  getParentRoute: () => rootRouteImport,
} as any)
const AgencyRoute = AgencyRouteImport.update({
  id: '/agency',
  path: '/agency',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StaysIdRoute = StaysIdRouteImport.update({
  id: '/stays_/$id',
  path: '/stays/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const MyBookingsReferenceRoute = MyBookingsReferenceRouteImport.update({
  id: '/my-bookings_/$reference',
  path: '/my-bookings/$reference',
  getParentRoute: () => rootRouteImport,
} as any)
const AgencySignupRoute = AgencySignupRouteImport.update({
  id: '/agency_/signup',
  path: '/agency/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminTaxiRoute = AuthenticatedAdminTaxiRouteImport.update({
  id: '/taxi',
  path: '/taxi',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminSettingsRoute =
  AuthenticatedAdminSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminReportsRoute =
  AuthenticatedAdminReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminRefundsRoute =
  AuthenticatedAdminRefundsRouteImport.update({
    id: '/refunds',
    path: '/refunds',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminEnquiriesRoute =
  AuthenticatedAdminEnquiriesRouteImport.update({
    id: '/enquiries',
    path: '/enquiries',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminDriversRoute =
  AuthenticatedAdminDriversRouteImport.update({
    id: '/drivers',
    path: '/drivers',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminChannelsRoute =
  AuthenticatedAdminChannelsRouteImport.update({
    id: '/channels',
    path: '/channels',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminCalendarRoute =
  AuthenticatedAdminCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminBookingsRoute =
  AuthenticatedAdminBookingsRouteImport.update({
    id: '/bookings',
    path: '/bookings',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminBeds24Route =
  AuthenticatedAdminBeds24RouteImport.update({
    id: '/beds24',
    path: '/beds24',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminApartmentsRoute =
  AuthenticatedAdminApartmentsRouteImport.update({
    id: '/apartments',
    path: '/apartments',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAgenciesRoute =
  AuthenticatedAdminAgenciesRouteImport.update({
    id: '/agencies',
    path: '/agencies',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminChannelsIndexRoute =
  AuthenticatedAdminChannelsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAdminChannelsRoute,
  } as any)
const AuthenticatedAdminTaxiIdRoute =
  AuthenticatedAdminTaxiIdRouteImport.update({
    id: '/taxi_/$id',
    path: '/taxi/$id',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminInsightsSlugRoute =
  AuthenticatedAdminInsightsSlugRouteImport.update({
    id: '/insights/$slug',
    path: '/insights/$slug',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminDriversIdRoute =
  AuthenticatedAdminDriversIdRouteImport.update({
    id: '/drivers_/$id',
    path: '/drivers/$id',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminChannelsVrboRoute =
  AuthenticatedAdminChannelsVrboRouteImport.update({
    id: '/vrbo',
    path: '/vrbo',
    getParentRoute: () => AuthenticatedAdminChannelsRoute,
  } as any)
const AuthenticatedAdminChannelsExpediaRoute =
  AuthenticatedAdminChannelsExpediaRouteImport.update({
    id: '/expedia',
    path: '/expedia',
    getParentRoute: () => AuthenticatedAdminChannelsRoute,
  } as any)
const AuthenticatedAdminChannelsDirectRoute =
  AuthenticatedAdminChannelsDirectRouteImport.update({
    id: '/direct',
    path: '/direct',
    getParentRoute: () => AuthenticatedAdminChannelsRoute,
  } as any)
const AuthenticatedAdminChannelsBookingRoute =
  AuthenticatedAdminChannelsBookingRouteImport.update({
    id: '/booking',
    path: '/booking',
    getParentRoute: () => AuthenticatedAdminChannelsRoute,
  } as any)
const AuthenticatedAdminChannelsAirbnbRoute =
  AuthenticatedAdminChannelsAirbnbRouteImport.update({
    id: '/airbnb',
    path: '/airbnb',
    getParentRoute: () => AuthenticatedAdminChannelsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/agency': typeof AgencyRoute
  '/amenities': typeof AmenitiesRoute
  '/auth': typeof AuthRoute
  '/book': typeof BookRoute
  '/booking-policy': typeof BookingPolicyRoute
  '/contact': typeof ContactRoute
  '/cookies': typeof CookiesRoute
  '/driver': typeof DriverRoute
  '/my-bookings': typeof MyBookingsRoute
  '/privacy': typeof PrivacyRoute
  '/stays': typeof StaysRoute
  '/taxi': typeof TaxiRoute
  '/terms': typeof TermsRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/agency/signup': typeof AgencySignupRoute
  '/my-bookings/$reference': typeof MyBookingsReferenceRoute
  '/stays/$id': typeof StaysIdRoute
  '/admin/agencies': typeof AuthenticatedAdminAgenciesRoute
  '/admin/apartments': typeof AuthenticatedAdminApartmentsRoute
  '/admin/beds24': typeof AuthenticatedAdminBeds24Route
  '/admin/bookings': typeof AuthenticatedAdminBookingsRoute
  '/admin/calendar': typeof AuthenticatedAdminCalendarRoute
  '/admin/channels': typeof AuthenticatedAdminChannelsRouteWithChildren
  '/admin/drivers': typeof AuthenticatedAdminDriversRoute
  '/admin/enquiries': typeof AuthenticatedAdminEnquiriesRoute
  '/admin/refunds': typeof AuthenticatedAdminRefundsRoute
  '/admin/reports': typeof AuthenticatedAdminReportsRoute
  '/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/admin/taxi': typeof AuthenticatedAdminTaxiRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/admin/': typeof AuthenticatedAdminIndexRoute
  '/admin/channels/airbnb': typeof AuthenticatedAdminChannelsAirbnbRoute
  '/admin/channels/booking': typeof AuthenticatedAdminChannelsBookingRoute
  '/admin/channels/direct': typeof AuthenticatedAdminChannelsDirectRoute
  '/admin/channels/expedia': typeof AuthenticatedAdminChannelsExpediaRoute
  '/admin/channels/vrbo': typeof AuthenticatedAdminChannelsVrboRoute
  '/admin/drivers/$id': typeof AuthenticatedAdminDriversIdRoute
  '/admin/insights/$slug': typeof AuthenticatedAdminInsightsSlugRoute
  '/admin/taxi/$id': typeof AuthenticatedAdminTaxiIdRoute
  '/admin/channels/': typeof AuthenticatedAdminChannelsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/agency': typeof AgencyRoute
  '/amenities': typeof AmenitiesRoute
  '/auth': typeof AuthRoute
  '/book': typeof BookRoute
  '/booking-policy': typeof BookingPolicyRoute
  '/contact': typeof ContactRoute
  '/cookies': typeof CookiesRoute
  '/driver': typeof DriverRoute
  '/my-bookings': typeof MyBookingsRoute
  '/privacy': typeof PrivacyRoute
  '/stays': typeof StaysRoute
  '/taxi': typeof TaxiRoute
  '/terms': typeof TermsRoute
  '/agency/signup': typeof AgencySignupRoute
  '/my-bookings/$reference': typeof MyBookingsReferenceRoute
  '/stays/$id': typeof StaysIdRoute
  '/admin/agencies': typeof AuthenticatedAdminAgenciesRoute
  '/admin/apartments': typeof AuthenticatedAdminApartmentsRoute
  '/admin/beds24': typeof AuthenticatedAdminBeds24Route
  '/admin/bookings': typeof AuthenticatedAdminBookingsRoute
  '/admin/calendar': typeof AuthenticatedAdminCalendarRoute
  '/admin/drivers': typeof AuthenticatedAdminDriversRoute
  '/admin/enquiries': typeof AuthenticatedAdminEnquiriesRoute
  '/admin/refunds': typeof AuthenticatedAdminRefundsRoute
  '/admin/reports': typeof AuthenticatedAdminReportsRoute
  '/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/admin/taxi': typeof AuthenticatedAdminTaxiRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/admin/channels/airbnb': typeof AuthenticatedAdminChannelsAirbnbRoute
  '/admin/channels/booking': typeof AuthenticatedAdminChannelsBookingRoute
  '/admin/channels/direct': typeof AuthenticatedAdminChannelsDirectRoute
  '/admin/channels/expedia': typeof AuthenticatedAdminChannelsExpediaRoute
  '/admin/channels/vrbo': typeof AuthenticatedAdminChannelsVrboRoute
  '/admin/drivers/$id': typeof AuthenticatedAdminDriversIdRoute
  '/admin/insights/$slug': typeof AuthenticatedAdminInsightsSlugRoute
  '/admin/taxi/$id': typeof AuthenticatedAdminTaxiIdRoute
  '/admin/channels': typeof AuthenticatedAdminChannelsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/agency': typeof AgencyRoute
  '/amenities': typeof AmenitiesRoute
  '/auth': typeof AuthRoute
  '/book': typeof BookRoute
  '/booking-policy': typeof BookingPolicyRoute
  '/contact': typeof ContactRoute
  '/cookies': typeof CookiesRoute
  '/driver': typeof DriverRoute
  '/my-bookings': typeof MyBookingsRoute
  '/privacy': typeof PrivacyRoute
  '/stays': typeof StaysRoute
  '/taxi': typeof TaxiRoute
  '/terms': typeof TermsRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteWithChildren
  '/agency_/signup': typeof AgencySignupRoute
  '/my-bookings_/$reference': typeof MyBookingsReferenceRoute
  '/stays_/$id': typeof StaysIdRoute
  '/_authenticated/admin/agencies': typeof AuthenticatedAdminAgenciesRoute
  '/_authenticated/admin/apartments': typeof AuthenticatedAdminApartmentsRoute
  '/_authenticated/admin/beds24': typeof AuthenticatedAdminBeds24Route
  '/_authenticated/admin/bookings': typeof AuthenticatedAdminBookingsRoute
  '/_authenticated/admin/calendar': typeof AuthenticatedAdminCalendarRoute
  '/_authenticated/admin/channels': typeof AuthenticatedAdminChannelsRouteWithChildren
  '/_authenticated/admin/drivers': typeof AuthenticatedAdminDriversRoute
  '/_authenticated/admin/enquiries': typeof AuthenticatedAdminEnquiriesRoute
  '/_authenticated/admin/refunds': typeof AuthenticatedAdminRefundsRoute
  '/_authenticated/admin/reports': typeof AuthenticatedAdminReportsRoute
  '/_authenticated/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/_authenticated/admin/taxi': typeof AuthenticatedAdminTaxiRoute
  '/_authenticated/admin/users': typeof AuthenticatedAdminUsersRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
  '/_authenticated/admin/channels/airbnb': typeof AuthenticatedAdminChannelsAirbnbRoute
  '/_authenticated/admin/channels/booking': typeof AuthenticatedAdminChannelsBookingRoute
  '/_authenticated/admin/channels/direct': typeof AuthenticatedAdminChannelsDirectRoute
  '/_authenticated/admin/channels/expedia': typeof AuthenticatedAdminChannelsExpediaRoute
  '/_authenticated/admin/channels/vrbo': typeof AuthenticatedAdminChannelsVrboRoute
  '/_authenticated/admin/drivers_/$id': typeof AuthenticatedAdminDriversIdRoute
  '/_authenticated/admin/insights/$slug': typeof AuthenticatedAdminInsightsSlugRoute
  '/_authenticated/admin/taxi_/$id': typeof AuthenticatedAdminTaxiIdRoute
  '/_authenticated/admin/channels/': typeof AuthenticatedAdminChannelsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/agency'
    | '/amenities'
    | '/auth'
    | '/book'
    | '/booking-policy'
    | '/contact'
    | '/cookies'
    | '/driver'
    | '/my-bookings'
    | '/privacy'
    | '/stays'
    | '/taxi'
    | '/terms'
    | '/admin'
    | '/agency/signup'
    | '/my-bookings/$reference'
    | '/stays/$id'
    | '/admin/agencies'
    | '/admin/apartments'
    | '/admin/beds24'
    | '/admin/bookings'
    | '/admin/calendar'
    | '/admin/channels'
    | '/admin/drivers'
    | '/admin/enquiries'
    | '/admin/refunds'
    | '/admin/reports'
    | '/admin/settings'
    | '/admin/taxi'
    | '/admin/users'
    | '/admin/'
    | '/admin/channels/airbnb'
    | '/admin/channels/booking'
    | '/admin/channels/direct'
    | '/admin/channels/expedia'
    | '/admin/channels/vrbo'
    | '/admin/drivers/$id'
    | '/admin/insights/$slug'
    | '/admin/taxi/$id'
    | '/admin/channels/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/agency'
    | '/amenities'
    | '/auth'
    | '/book'
    | '/booking-policy'
    | '/contact'
    | '/cookies'
    | '/driver'
    | '/my-bookings'
    | '/privacy'
    | '/stays'
    | '/taxi'
    | '/terms'
    | '/agency/signup'
    | '/my-bookings/$reference'
    | '/stays/$id'
    | '/admin/agencies'
    | '/admin/apartments'
    | '/admin/beds24'
    | '/admin/bookings'
    | '/admin/calendar'
    | '/admin/drivers'
    | '/admin/enquiries'
    | '/admin/refunds'
    | '/admin/reports'
    | '/admin/settings'
    | '/admin/taxi'
    | '/admin/users'
    | '/admin'
    | '/admin/channels/airbnb'
    | '/admin/channels/booking'
    | '/admin/channels/direct'
    | '/admin/channels/expedia'
    | '/admin/channels/vrbo'
    | '/admin/drivers/$id'
    | '/admin/insights/$slug'
    | '/admin/taxi/$id'
    | '/admin/channels'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/agency'
    | '/amenities'
    | '/auth'
    | '/book'
    | '/booking-policy'
    | '/contact'
    | '/cookies'
    | '/driver'
    | '/my-bookings'
    | '/privacy'
    | '/stays'
    | '/taxi'
    | '/terms'
    | '/_authenticated/admin'
    | '/agency_/signup'
    | '/my-bookings_/$reference'
    | '/stays_/$id'
    | '/_authenticated/admin/agencies'
    | '/_authenticated/admin/apartments'
    | '/_authenticated/admin/beds24'
    | '/_authenticated/admin/bookings'
    | '/_authenticated/admin/calendar'
    | '/_authenticated/admin/channels'
    | '/_authenticated/admin/drivers'
    | '/_authenticated/admin/enquiries'
    | '/_authenticated/admin/refunds'
    | '/_authenticated/admin/reports'
    | '/_authenticated/admin/settings'
    | '/_authenticated/admin/taxi'
    | '/_authenticated/admin/users'
    | '/_authenticated/admin/'
    | '/_authenticated/admin/channels/airbnb'
    | '/_authenticated/admin/channels/booking'
    | '/_authenticated/admin/channels/direct'
    | '/_authenticated/admin/channels/expedia'
    | '/_authenticated/admin/channels/vrbo'
    | '/_authenticated/admin/drivers_/$id'
    | '/_authenticated/admin/insights/$slug'
    | '/_authenticated/admin/taxi_/$id'
    | '/_authenticated/admin/channels/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  AgencyRoute: typeof AgencyRoute
  AmenitiesRoute: typeof AmenitiesRoute
  AuthRoute: typeof AuthRoute
  BookRoute: typeof BookRoute
  BookingPolicyRoute: typeof BookingPolicyRoute
  ContactRoute: typeof ContactRoute
  CookiesRoute: typeof CookiesRoute
  DriverRoute: typeof DriverRoute
  MyBookingsRoute: typeof MyBookingsRoute
  PrivacyRoute: typeof PrivacyRoute
  StaysRoute: typeof StaysRoute
  TaxiRoute: typeof TaxiRoute
  TermsRoute: typeof TermsRoute
  AgencySignupRoute: typeof AgencySignupRoute
  MyBookingsReferenceRoute: typeof MyBookingsReferenceRoute
  StaysIdRoute: typeof StaysIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/taxi': {
      id: '/taxi'
      path: '/taxi'
      fullPath: '/taxi'
      preLoaderRoute: typeof TaxiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stays': {
      id: '/stays'
      path: '/stays'
      fullPath: '/stays'
      preLoaderRoute: typeof StaysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-bookings': {
      id: '/my-bookings'
      path: '/my-bookings'
      fullPath: '/my-bookings'
      preLoaderRoute: typeof MyBookingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/driver': {
      id: '/driver'
      path: '/driver'
      fullPath: '/driver'
      preLoaderRoute: typeof DriverRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cookies': {
      id: '/cookies'
      path: '/cookies'
      fullPath: '/cookies'
      preLoaderRoute: typeof CookiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking-policy': {
      id: '/booking-policy'
      path: '/booking-policy'
      fullPath: '/booking-policy'
      preLoaderRoute: typeof BookingPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/book': {
      id: '/book'
      path: '/book'
      fullPath: '/book'
      preLoaderRoute: typeof BookRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/amenities': {
      id: '/amenities'
      path: '/amenities'
      fullPath: '/amenities'
      preLoaderRoute: typeof AmenitiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agency': {
      id: '/agency'
      path: '/agency'
      fullPath: '/agency'
      preLoaderRoute: typeof AgencyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stays_/$id': {
      id: '/stays_/$id'
      path: '/stays/$id'
      fullPath: '/stays/$id'
      preLoaderRoute: typeof StaysIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-bookings_/$reference': {
      id: '/my-bookings_/$reference'
      path: '/my-bookings/$reference'
      fullPath: '/my-bookings/$reference'
      preLoaderRoute: typeof MyBookingsReferenceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agency_/signup': {
      id: '/agency_/signup'
      path: '/agency/signup'
      fullPath: '/agency/signup'
      preLoaderRoute: typeof AgencySignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/users': {
      id: '/_authenticated/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthenticatedAdminUsersRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/taxi': {
      id: '/_authenticated/admin/taxi'
      path: '/taxi'
      fullPath: '/admin/taxi'
      preLoaderRoute: typeof AuthenticatedAdminTaxiRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/settings': {
      id: '/_authenticated/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AuthenticatedAdminSettingsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/reports': {
      id: '/_authenticated/admin/reports'
      path: '/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AuthenticatedAdminReportsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/refunds': {
      id: '/_authenticated/admin/refunds'
      path: '/refunds'
      fullPath: '/admin/refunds'
      preLoaderRoute: typeof AuthenticatedAdminRefundsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/enquiries': {
      id: '/_authenticated/admin/enquiries'
      path: '/enquiries'
      fullPath: '/admin/enquiries'
      preLoaderRoute: typeof AuthenticatedAdminEnquiriesRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/drivers': {
      id: '/_authenticated/admin/drivers'
      path: '/drivers'
      fullPath: '/admin/drivers'
      preLoaderRoute: typeof AuthenticatedAdminDriversRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/channels': {
      id: '/_authenticated/admin/channels'
      path: '/channels'
      fullPath: '/admin/channels'
      preLoaderRoute: typeof AuthenticatedAdminChannelsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/calendar': {
      id: '/_authenticated/admin/calendar'
      path: '/calendar'
      fullPath: '/admin/calendar'
      preLoaderRoute: typeof AuthenticatedAdminCalendarRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/bookings': {
      id: '/_authenticated/admin/bookings'
      path: '/bookings'
      fullPath: '/admin/bookings'
      preLoaderRoute: typeof AuthenticatedAdminBookingsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/beds24': {
      id: '/_authenticated/admin/beds24'
      path: '/beds24'
      fullPath: '/admin/beds24'
      preLoaderRoute: typeof AuthenticatedAdminBeds24RouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/apartments': {
      id: '/_authenticated/admin/apartments'
      path: '/apartments'
      fullPath: '/admin/apartments'
      preLoaderRoute: typeof AuthenticatedAdminApartmentsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/agencies': {
      id: '/_authenticated/admin/agencies'
      path: '/agencies'
      fullPath: '/admin/agencies'
      preLoaderRoute: typeof AuthenticatedAdminAgenciesRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/channels/': {
      id: '/_authenticated/admin/channels/'
      path: '/'
      fullPath: '/admin/channels/'
      preLoaderRoute: typeof AuthenticatedAdminChannelsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminChannelsRoute
    }
    '/_authenticated/admin/taxi_/$id': {
      id: '/_authenticated/admin/taxi_/$id'
      path: '/taxi/$id'
      fullPath: '/admin/taxi/$id'
      preLoaderRoute: typeof AuthenticatedAdminTaxiIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/insights/$slug': {
      id: '/_authenticated/admin/insights/$slug'
      path: '/insights/$slug'
      fullPath: '/admin/insights/$slug'
      preLoaderRoute: typeof AuthenticatedAdminInsightsSlugRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/drivers_/$id': {
      id: '/_authenticated/admin/drivers_/$id'
      path: '/drivers/$id'
      fullPath: '/admin/drivers/$id'
      preLoaderRoute: typeof AuthenticatedAdminDriversIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/channels/vrbo': {
      id: '/_authenticated/admin/channels/vrbo'
      path: '/vrbo'
      fullPath: '/admin/channels/vrbo'
      preLoaderRoute: typeof AuthenticatedAdminChannelsVrboRouteImport
      parentRoute: typeof AuthenticatedAdminChannelsRoute
    }
    '/_authenticated/admin/channels/expedia': {
      id: '/_authenticated/admin/channels/expedia'
      path: '/expedia'
      fullPath: '/admin/channels/expedia'
      preLoaderRoute: typeof AuthenticatedAdminChannelsExpediaRouteImport
      parentRoute: typeof AuthenticatedAdminChannelsRoute
    }
    '/_authenticated/admin/channels/direct': {
      id: '/_authenticated/admin/channels/direct'
      path: '/direct'
      fullPath: '/admin/channels/direct'
      preLoaderRoute: typeof AuthenticatedAdminChannelsDirectRouteImport
      parentRoute: typeof AuthenticatedAdminChannelsRoute
    }
    '/_authenticated/admin/channels/booking': {
      id: '/_authenticated/admin/channels/booking'
      path: '/booking'
      fullPath: '/admin/channels/booking'
      preLoaderRoute: typeof AuthenticatedAdminChannelsBookingRouteImport
      parentRoute: typeof AuthenticatedAdminChannelsRoute
    }
    '/_authenticated/admin/channels/airbnb': {
      id: '/_authenticated/admin/channels/airbnb'
      path: '/airbnb'
      fullPath: '/admin/channels/airbnb'
      preLoaderRoute: typeof AuthenticatedAdminChannelsAirbnbRouteImport
      parentRoute: typeof AuthenticatedAdminChannelsRoute
    }
  }
}

interface AuthenticatedAdminChannelsRouteChildren {
  AuthenticatedAdminChannelsAirbnbRoute: typeof AuthenticatedAdminChannelsAirbnbRoute
  AuthenticatedAdminChannelsBookingRoute: typeof AuthenticatedAdminChannelsBookingRoute
  AuthenticatedAdminChannelsDirectRoute: typeof AuthenticatedAdminChannelsDirectRoute
  AuthenticatedAdminChannelsExpediaRoute: typeof AuthenticatedAdminChannelsExpediaRoute
  AuthenticatedAdminChannelsVrboRoute: typeof AuthenticatedAdminChannelsVrboRoute
  AuthenticatedAdminChannelsIndexRoute: typeof AuthenticatedAdminChannelsIndexRoute
}

const AuthenticatedAdminChannelsRouteChildren: AuthenticatedAdminChannelsRouteChildren =
  {
    AuthenticatedAdminChannelsAirbnbRoute:
      AuthenticatedAdminChannelsAirbnbRoute,
    AuthenticatedAdminChannelsBookingRoute:
      AuthenticatedAdminChannelsBookingRoute,
    AuthenticatedAdminChannelsDirectRoute:
      AuthenticatedAdminChannelsDirectRoute,
    AuthenticatedAdminChannelsExpediaRoute:
      AuthenticatedAdminChannelsExpediaRoute,
    AuthenticatedAdminChannelsVrboRoute: AuthenticatedAdminChannelsVrboRoute,
    AuthenticatedAdminChannelsIndexRoute: AuthenticatedAdminChannelsIndexRoute,
  }

const AuthenticatedAdminChannelsRouteWithChildren =
  AuthenticatedAdminChannelsRoute._addFileChildren(
    AuthenticatedAdminChannelsRouteChildren,
  )

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminAgenciesRoute: typeof AuthenticatedAdminAgenciesRoute
  AuthenticatedAdminApartmentsRoute: typeof AuthenticatedAdminApartmentsRoute
  AuthenticatedAdminBeds24Route: typeof AuthenticatedAdminBeds24Route
  AuthenticatedAdminBookingsRoute: typeof AuthenticatedAdminBookingsRoute
  AuthenticatedAdminCalendarRoute: typeof AuthenticatedAdminCalendarRoute
  AuthenticatedAdminChannelsRoute: typeof AuthenticatedAdminChannelsRouteWithChildren
  AuthenticatedAdminDriversRoute: typeof AuthenticatedAdminDriversRoute
  AuthenticatedAdminEnquiriesRoute: typeof AuthenticatedAdminEnquiriesRoute
  AuthenticatedAdminRefundsRoute: typeof AuthenticatedAdminRefundsRoute
  AuthenticatedAdminReportsRoute: typeof AuthenticatedAdminReportsRoute
  AuthenticatedAdminSettingsRoute: typeof AuthenticatedAdminSettingsRoute
  AuthenticatedAdminTaxiRoute: typeof AuthenticatedAdminTaxiRoute
  AuthenticatedAdminUsersRoute: typeof AuthenticatedAdminUsersRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
  AuthenticatedAdminDriversIdRoute: typeof AuthenticatedAdminDriversIdRoute
  AuthenticatedAdminInsightsSlugRoute: typeof AuthenticatedAdminInsightsSlugRoute
  AuthenticatedAdminTaxiIdRoute: typeof AuthenticatedAdminTaxiIdRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAgenciesRoute: AuthenticatedAdminAgenciesRoute,
  AuthenticatedAdminApartmentsRoute: AuthenticatedAdminApartmentsRoute,
  AuthenticatedAdminBeds24Route: AuthenticatedAdminBeds24Route,
  AuthenticatedAdminBookingsRoute: AuthenticatedAdminBookingsRoute,
  AuthenticatedAdminCalendarRoute: AuthenticatedAdminCalendarRoute,
  AuthenticatedAdminChannelsRoute: AuthenticatedAdminChannelsRouteWithChildren,
  AuthenticatedAdminDriversRoute: AuthenticatedAdminDriversRoute,
  AuthenticatedAdminEnquiriesRoute: AuthenticatedAdminEnquiriesRoute,
  AuthenticatedAdminRefundsRoute: AuthenticatedAdminRefundsRoute,
  AuthenticatedAdminReportsRoute: AuthenticatedAdminReportsRoute,
  AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,
  AuthenticatedAdminTaxiRoute: AuthenticatedAdminTaxiRoute,
  AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,
  AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
  AuthenticatedAdminDriversIdRoute: AuthenticatedAdminDriversIdRoute,
  AuthenticatedAdminInsightsSlugRoute: AuthenticatedAdminInsightsSlugRoute,
  AuthenticatedAdminTaxiIdRoute: AuthenticatedAdminTaxiIdRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  AgencyRoute: AgencyRoute,
  AmenitiesRoute: AmenitiesRoute,
  AuthRoute: AuthRoute,
  BookRoute: BookRoute,
  BookingPolicyRoute: BookingPolicyRoute,
  ContactRoute: ContactRoute,
  CookiesRoute: CookiesRoute,
  DriverRoute: DriverRoute,
  MyBookingsRoute: MyBookingsRoute,
  PrivacyRoute: PrivacyRoute,
  StaysRoute: StaysRoute,
  TaxiRoute: TaxiRoute,
  TermsRoute: TermsRoute,
  AgencySignupRoute: AgencySignupRoute,
  MyBookingsReferenceRoute: MyBookingsReferenceRoute,
  StaysIdRoute: StaysIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
